import { Box, CircularProgress } from '@mui/material';

const LoadingSpinner = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        backgroundColor: 'rgba(0, 0, 0, 0.02)',
      }}
    >
      <CircularProgress size={40} />
    </Box>
  );
};

export default LoadingSpinner; 